/* eslint-disable spaced-comment */
import 'lazysizes';
import * as React from 'react';
import { cn } from '../../../helpers';
import buildImageUrl from '../../../utilities/build-image-url';
import SPGVariables from '../../../utilities/spg-variables';

const REGEXP_DECIMAL_NUMBER = /\d+(?:\.\d+)?/;
const REGEXP_DESCRIPTOR_WIDTH = new RegExp(`^${REGEXP_DECIMAL_NUMBER.source}w$`);
const REGEXP_DESCRIPTOR_PIXEL = new RegExp(`^${REGEXP_DECIMAL_NUMBER.source}x$`);

const spgVariables = SPGVariables();

function matchWidthDescriptor(str: string) {
    return REGEXP_DESCRIPTOR_WIDTH.test(str);
}

function matchPixelDescriptor(str: string) {
    return REGEXP_DESCRIPTOR_PIXEL.test(str);
}

function buildSrcSet(sources: ImageSourceObject) {
    const isWidthDescriptior = Object.keys(sources).every(descriptor => matchWidthDescriptor(descriptor));
    const matcher = isWidthDescriptior ? matchWidthDescriptor : matchPixelDescriptor;
    return (
        Object.keys(sources)
            .filter(matcher)
            .map(descriptor => `${sources[descriptor]} ${descriptor}`)
            .join(',') || undefined
    );
}

function ImageComponent(props: ImageProps) {
    if (spgVariables.IS_CRAWLER_REQUEST) return null;
    const { alt, className, src, sources, sizes, onLoaded, ...rest } = props;
    const srcSet = sources ? buildSrcSet(sources) : undefined;
    const onImageLoaded = () => {
        if (onLoaded) onLoaded();
    };
    if (!src) return null;
    return (
        <img
            {...rest}
            sizes={sizes}
            data-src={buildImageUrl(src)}
            srcSet={srcSet}
            alt={alt || ''}
            className={cn('image', 'lazyload', className)}
            onLoad={onImageLoaded}
        />
    );
}

export default React.memo(ImageComponent);
